import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@shared/services/api/apiRequest";
import { USER_CIRCLES_SET, usePlatformDispatch } from "../PlatformContext";
import { Circle } from "../types/platform.types";
import moment from "moment";

export type Args = {
  isEnabled?: boolean;
  refetchOnWindowFocus?: boolean;
  refetchOnReconnect?: boolean;
};

export function useFetchUserCircles(
  {
    isEnabled = true,
    refetchOnWindowFocus = true,
    refetchOnReconnect = true,
  }: Args = {
    isEnabled: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  }
) {
  const dispatch = usePlatformDispatch();

  const query = useQuery({
    queryKey: ["user-circles"],

    queryFn: async () => {
      return await apiRequest(`/api/get-my-circles/`, "GET");
    },

    // Select the circles from the response
    select: (data) => {
      return data.circles.map((circle: Circle) => ({
        ...circle,
        meetings: circle.meetings.sort(
          (a, b) =>
            moment(a.start_time).valueOf() - moment(b.start_time).valueOf()
        ),
      }));
    },

    // Disable retry to avoid repeated failures
    retry: false,
    enabled: isEnabled,
    refetchOnWindowFocus: refetchOnWindowFocus,
    refetchOnReconnect: refetchOnReconnect,
  });

  useEffect(() => {
    if (query.data) {
      dispatch({
        type: USER_CIRCLES_SET,
        payload: { userCircles: query.data },
      });
    }
  }, [query.data]);

  return query;
}

export default useFetchUserCircles;
